var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyebrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 142.83 77.18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.64 1.65c37.46 0 71.53 10 101.55 26.69 17 9.45 29.38 19 36.69 26l1.31 1.29-19.9 19.9a98.89 98.89 0 00-7.8-6.69A179.86 179.86 0 0089.52 53 179.65 179.65 0 006.24 29.86l-4.6-.06z",
    stroke: "#ecb989",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    "data-name": "Ebene 2"
  })));
}
export default __webpack_public_path__ + "42dc96af8b7d6758560b7e27d9dbacdd.svg";
export { SvgEyebrowRight as ReactComponent };